module.exports = __webpack_public_path__ + "assets/img/drone.fef89e7b.png";